<div class="flex flex-col lg:flex-row h-full w-full bg-grey-100 lg:p-4 lg:gap-4">
  <svc-settings-nav class="lg:rounded-lg shadow-sm overflow-hidden" [activeSection]="activeSection"
    (sectionChange)="activeSection = $event">
  </svc-settings-nav>
  <div class="flex-1 lg:rounded-lg shadow-sm overflow-hidden bg-white min-h-0">
    <ng-container [ngSwitch]="activeSection">
      <svc-motor-mapping *ngSwitchCase="'service-mapping'"></svc-motor-mapping>
      <svc-dealer-recommendations *ngSwitchCase="'dealer-recommendations'"></svc-dealer-recommendations>
    </ng-container>
  </div>
</div>
